export const initGA = (measurementId) => {
  if (!measurementId) return

  // Prevent double-initialization (React StrictMode runs effects twice in dev)
  if (window.__gaInitialized) return
  window.__gaInitialized = true

  // Init dataLayer + gtag function immediately
  window.dataLayer = window.dataLayer || []

  function gtag() {
    window.dataLayer.push(arguments)
  }

  window.gtag = window.gtag || gtag

  window.gtag('js', new Date())
  window.gtag('config', measurementId)

  // Inject gtag.js script
  const selector = `script[src*="gtag/js?id=${measurementId}"]`
  const existing = document.querySelector(selector)

  if (!existing) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
      measurementId
    )}`
    document.head.appendChild(script)
  }
}

export const trackPageView = (measurementId, path) => {
  if (!measurementId || !window.gtag) return

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: document.title,
  })
}
